import { PAGE_CACHE_HEADERS } from "@/lib/ssrCache";
import { ensureExists } from "@/lib/ensureExists";
import { createFileRoute, notFound } from "@tanstack/react-router";
import { generatorProductQueryOptions } from "@/lib/productPageQuery";
import GeneratorProduct from "@/pages/GeneratorProduct";
import { redirectIfPruned } from "@/lib/prunedRedirect";

export const Route = createFileRoute("/generators/$slug")({
  beforeLoad: async ({ params }) => {
    await redirectIfPruned("generators", params.slug);
    await ensureExists("generators", params.slug);
  },
  loader: async ({ params, context }) => {
    const product = await context.queryClient.ensureQueryData(generatorProductQueryOptions(params.slug));
    if (!product) throw notFound();
    return { product };
  },
  component: GeneratorProduct,
  headers: () => PAGE_CACHE_HEADERS,
  head: ({ params, loaderData }) => {
    const canonicalUrl = "https://www.garden-review.co.uk" + `/generators/${params.slug}`;
    const generator = loaderData?.product;
    if (!generator) return {};
    const title = `${generator.brand} ${generator.model} — Specs, Price & Where to Buy in the UK`;
    const description = generator.description ? `${generator.description.slice(0, 140)}…` : `${generator.brand} ${generator.model} — compare prices from UK retailers. ${generator.best_for || "Find the best deal today."}`;
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:url", content: canonicalUrl },
        { property: "og:type", content: "product" },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
        ...(generator.image_url?.startsWith("https://") ? [
          { property: "og:image", content: generator.image_url },
          { name: "twitter:image", content: generator.image_url },
        ] : []),
      ],
      links: [{ rel: "canonical", href: canonicalUrl }],
    };
  },
});
